import { Col } from "antd";
import axios from "axios";
import AdminBreadcrumb from "components/AdminBreadCrumb/AdminBreadCrumb";
import Forbidden403NotIT from "components/ErrorPage/Forbidden403/Forbidden403NotIT";
import { CreateEvent, EditEvent } from "containers/Admin/CreateOrEditEvent/CreateOrEditEvent";
import { isBlMemberUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { BLgroupMember } from "interfaces/internal";
import { useEffect, useState } from "react";
import useViewport from "components/UseViewport/UseViewport";
import { Route, Switch } from "react-router-dom";
import AdminDashboard from "./AdminDashboard/AdminDashboard";
import AdminSingleEventPage from "./AdminSingleEvent/AdminSingleEventPage";
import AdminCompaniesList from "./Companies/AdminCompaniesList";
import AdminEvents from "./Events/AdminEvents";
import { CreateJob, EditJob } from "./Jobs/AdminJobs";
import Members from "./Members/Members";
import AdminResources from "./Resources/AdminResources";
import EventSeats from "./Seats/EventSeats";
import SelectCompanyForNewEvent from "./SelectCompanyForNewEvent/SelectCompanyForNewEvent";
import AdminSingleCompany from "./SingleCompany/SingleCompany";
import AdminSingleStudent from "./SingleStudent/SingleStudent";
import AdminStudentsList from "./Students/AdminStudentsList";
import AdminTools from "./Tools/AdminTools";

const AdminPage = () => {
  const { currentUser } = useLoginContext();
  const { width } = useViewport();
  const [isItMember, setIsItMember] = useState<boolean>(false);
  const [thirdPath, setThirdtPath] = useState(window.location.pathname.split("/")[3] || "");

  useEffect(() => {
    if (!isBlMemberUser(currentUser)) return;
    axios.get<BLgroupMember[]>(`/internal/${currentUser.id}/groups/`).then(response => {
      setIsItMember(response.data.some(group => group.bl_group === 1));
    });
  }, [currentUser]);

  const checkUrl = () => {
    const paths = window.location.pathname.split("/");
    setThirdtPath(paths[3] || "");
  };

  useEffect(() => {
    checkUrl();
    window.addEventListener("popstate", checkUrl);
    window.addEventListener("pushState", checkUrl);
    window.addEventListener("click", checkUrl);

    return () => {
      window.removeEventListener("popstate", checkUrl);
      window.removeEventListener("pushState", checkUrl);
      window.removeEventListener("click", checkUrl);
    };
  }, []);

  if (!isBlMemberUser(currentUser)) return null;
  return (
    <Col lg={24} md={24} sm={24} xs={24} style={{ padding: width > 768 ? "48px" : "24px", paddingTop: "24px" }}>
      <AdminBreadcrumb />
      <Switch>
        {thirdPath === "booking-seasons" && !isItMember && <Route component={Forbidden403NotIT} />}
        <Route exact path="/admin/" component={AdminDashboard} />
        <Route exact path="/admin/events/" component={AdminEvents} />
        <Route exact path="/admin/events/new/" component={SelectCompanyForNewEvent} />
        <Route exact path="/admin/events/:id/" component={AdminSingleEventPage} />
        <Route path="/admin/events/:id/edit/" component={EditEvent} />
        <Route path="/admin/events/:id/seats/" component={EventSeats} />
        <Route path="/admin/events/new/:id" component={CreateEvent} />
        <Route exact path="/admin/companies/:id" component={AdminSingleCompany} />
        <Route exact path="/admin/companies/" component={AdminCompaniesList} />
        <Route path="/admin/companies/:id/edit-job/:jobId" component={EditJob} />
        <Route path="/admin/companies/:id/create-new-job/" component={CreateJob} />
        <Route path="/admin/students/:id" component={AdminSingleStudent} />
        <Route path="/admin/students/" component={AdminStudentsList} />
        <Route path="/admin/resources/" component={AdminResources} />
        <Route path="/admin/members/" component={Members} />
        <Route path="/admin/tools/" component={AdminTools} />
      </Switch>
    </Col>
  );
};

export default AdminPage;
